import Analytics from './analyticsInterface';

interface DynamicEvent {
    eventName: string;
    analyticItems: AnalyticsItem[];
}

interface AnalyticsItem {
    name: string;
    value: string | NestedValue;
}

interface NestedValue {
    [key: string]: string | NestedValue;
}

export class NoOpTracker implements Analytics {
    track(_trackingData?: { dynamicEvents?: DynamicEvent[] }): void {
        // Implement logic to send events to Google Analytics
    }
}
